import React from 'react';
import { useInView } from '../../hooks/useInView';

interface ScrollRevealProps {
  children: React.ReactNode;
  direction?: 'up' | 'down' | 'left' | 'right' | 'zoom' | 'fade';
  delay?: number;
  duration?: number;
  className?: string;
  triggerOnce?: boolean;
}

export const ScrollReveal: React.FC<ScrollRevealProps> = ({
  children,
  direction = 'up',
  delay = 0,
  duration = 700,
  className = '',
  triggerOnce = true,
}) => {
  const { ref, inView } = useInView({ triggerOnce, threshold: 0.1 });

  const getTransformClasses = () => {
    switch (direction) {
      case 'up':
        return inView
          ? 'opacity-100 translate-y-0 scale-100'
          : 'opacity-0 translate-y-12 scale-[0.98]';
      case 'down':
        return inView
          ? 'opacity-100 translate-y-0 scale-100'
          : 'opacity-0 -translate-y-12 scale-[0.98]';
      case 'left':
        return inView
          ? 'opacity-100 translate-x-0'
          : 'opacity-0 -translate-x-12';
      case 'right':
        return inView
          ? 'opacity-100 translate-x-0'
          : 'opacity-0 translate-x-12';
      case 'zoom':
        return inView
          ? 'opacity-100 scale-100'
          : 'opacity-0 scale-90';
      case 'fade':
      default:
        return inView ? 'opacity-100' : 'opacity-0';
    }
  };

  return (
    <div
      ref={ref}
      style={{
        transitionDuration: `${duration}ms`,
        transitionDelay: `${delay}ms`,
      }}
      className={`transition-all ease-[cubic-bezier(0.16,1,0.3,1)] transform will-change-transform ${getTransformClasses()} ${className}`}
    >
      {children}
    </div>
  );
};

export default ScrollReveal;
